import * as React from 'react'

import { Box, Button } from '@factorialco/deprecated-design-system'
import type { Form } from 'factorial-form'
import { action } from 'mobx'

import { dateUIToBackend } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

interface FooterProps {
  onApplyFilters: () => void
  toggle: (value: boolean) => () => void
  filtersForm: Form
}

const Footer = ({ onApplyFilters, toggle, filtersForm }: FooterProps) => {
  const applyFilters = () => {
    const dateFrom = dateUIToBackend(filtersForm.get('date_from').value)
    const dateTo = dateUIToBackend(filtersForm.get('date_to').value)

    if (dateFrom && dateTo && dateFrom > dateTo) {
      app.setFlash({
        type: 'wrong',
        message: i18n.t('settings.audit_log.filters.wrong_date_format'),
      })
    } else {
      onApplyFilters()
      toggle(false)()
    }
  }

  const resetForm = () => {
    action('reset', () => {
      filtersForm.resetAll()
    })()
  }

  return (
    <Box
      border={{
        top: {
          width: 's1',
          style: 'solid',
          color: 'darker160',
        },
      }}
      borderRadius={{
        bottomLeft: 'abs008',
        bottomRight: 'abs008',
      }}
      background="grey200"
      paddingY="s12"
      paddingX="s32"
      justifyContent="flexEnd"
      alignItems="center"
      flexDirection="row"
      flexWrap="wrap"
      gap="s8"
    >
      <Button type="secondary" onClick={resetForm}>
        {i18n.t('settings.audit_log.filters.reset')}
      </Button>
      <Button type="primary" onClick={applyFilters}>
        {i18n.t('settings.audit_log.filters.apply_filters')}
      </Button>
    </Box>
  )
}

export default Footer
